import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { CarouselModule } from 'ngx-owl-carousel-o';

import { HomeComponent } from './home.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { QuickLinksComponent } from './home-button-links/quick-links.component';

@NgModule({
  imports: [
      CommonModule,
      RouterModule,
      CarouselModule
  ],
  declarations: [
    HomeComponent,
    TestimonialsComponent,
    QuickLinksComponent
  ],
  exports: [
    HomeComponent,
    TestimonialsComponent,
    QuickLinksComponent
  ]
})

export class HomeModule { }
